import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export default function TabelaAproveitamentoColaborador({ dadosTabelaColaborador }) {

  const cardStyle = {
    background: "#FAFAFA",
    padding: "2rem",
    borderRadius: "10px",
    marginBottom: "1rem",
    marginTop: "1rem",
  };

  const tableHeaderStyle = {
    textAlign: "center",
    fontSize: "24px",
  };

  const formatDate = (dateString) => {
    if (!dateString || isNaN(new Date(dateString).getTime())) {
      return '';
    }
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  };


  return (
    <div style={cardStyle}>
      <DataTable
        scrollable
        scrollHeight="400px"
        header="Atividades Relacionadas"
        tableStyle={{ minWidth: "50rem" }}
        value={dadosTabelaColaborador}
        style={tableHeaderStyle}
      >
        <Column field="titulo_hu" sortable header="Titulo da atividade"/>
        <Column field="status_hu" sortable header="Status"/>
        <Column field="nome_projeto" sortable header="Projeto relacionado"/>
        <Column field="nome_epico" sortable header="Épico relacionado"/>
        <Column
          field="data_inicio"
          sortable 
          header="Data de início"
          body={(rowData) => formatDate(rowData.data_inicio)}
        />
        <Column
          field="data_fim"
          sortable 
          header="Data de fim"
          body={(rowData) => formatDate(rowData.data_fim)}
        />
        <Column field="tempo_esperado" sortable header="Tempo esperado"/>
        <Column field="tempo_gasto" sortable header="Tempo gasto"/>
      </DataTable>
    </div>
  );
}
